import TranslationKeys from "./translation-keys";

export default TranslationKeys;


